import React, { Component, Fragment } from 'react';
import UserRow from './UserRow';
import { Row, Col, Card, Table } from 'react-bootstrap';
import SearchFilter from '../Reusable/SearchFilter';
import ModalForAddUser from './ModalForAddUser';
import { Link } from 'react-router-dom';
import withTranslations from '../../utils/HighOrderComponent';
import { NotificationContainer } from 'react-notifications';

class UserTable extends Component {
  constructor() {
    super();
    this.state = {
      show: false,
    };
  }

  showModal = (e) => {
    this.props.findAllKjs();
    this.setState({
      show: true,
    });
  };

  handlePreviewClose = () => {
    this.setState({
      show: false,
    });
    this.props.clearKjsList();
  };

  handleAdd = (user, messages) => {
    this.props.createUserProtenant(user, this.handlePreviewClose, messages);
  };

  render() {
    const userList = this.props.userList.map((user, index) => (
      <UserRow
        index={index + 1}
        key={user.id}
        user={user}
        updateUser={this.props.updateUser}
        deleteUser={this.props.deleteUser}
        deactivateUser={this.props.deactivateUser}
        deactivate2fa={this.props.deactivate2fa}
        activateUser={this.props.activateUser}
        error={this.props.error}
        deleteError={this.props.deleteError}
        rolesHashMapList={this.props.rolesHashMapList}
        autonomousProvinceList={this.props.autonomousProvinceList}
        placeList={this.props.placeList}
        municipalityList={this.props.municipalityList}
        kjsList={this.props.kjsList}
        institutionTypeList={this.props.institutionTypeList}
        findAllPlaceByAutonomousProvince={
          this.props.findAllPlaceByAutonomousProvince
        }
        findAllMunicipalityByPlace={this.props.findAllMunicipalityByPlace}
        findAllKjsByInstitutionType={this.props.findAllKjsByInstitutionType}
        findAllPlaceWithoutAutonomousProvince={
          this.props.findAllPlaceWithoutAutonomousProvince
        }
        clearPlaceList={this.props.clearPlaceList}
        clearMunicipalityList={this.props.clearMunicipalityList}
        clearKjsList={this.props.clearKjsList}
        findAllPlace={this.props.findAllPlace}
        findAllKjs={this.props.findAllKjs}
        findAllKjsFilterPageable={this.props.findAllKjsFilterPageable}
      />
    ));

    const table = (
      <Row>
        <Col>
          <Card>
            <Card.Header>
              <Row>
                <Col className="col-md-8">
                  <Card.Title as="h3">{this.props.t.titleTable}</Card.Title>
                </Col>
                <Col className="col-md-3">
                  <SearchFilter noSearchColums={2} />
                </Col>
                <Col className="addUser col-md-1">
                  <Link id="addUser" onClick={() => this.showModal()} to="#">
                    <i className="fas fa-plus fa-2x" />
                  </Link>
                </Col>
              </Row>
            </Card.Header>
            <Table responsive hover id="table">
              <thead>
                <tr>
                  <th width="3%">#</th>
                  <th>{this.props.t.HeaderColumns.firstName}</th>
                  <th>{this.props.t.HeaderColumns.lastName}</th>
                  <th>{this.props.t.HeaderColumns.username}</th>
                  <th className="text-center">
                    {this.props.t.HeaderColumns.active}
                  </th>
                  <th className="text-center">
                    {this.props.t.HeaderColumns.activateDeactivate}
                  </th>
                  <th className="text-center">
                    {this.props.t.HeaderColumns.edit}
                  </th>
                </tr>
              </thead>
              <tbody>{userList}</tbody>
            </Table>
          </Card>
        </Col>
      </Row>
    );

    return (
      <Fragment>
        {table}
        {this.state.show && (
          <ModalForAddUser
            rolesHashMapList={this.props.rolesHashMapList}
            handleAdd={this.handleAdd}
            handleClose={this.handlePreviewClose}
            show={this.state.show}
            error={this.props.error}
            deleteError={this.props.deleteError}
            autonomousProvinceList={this.props.autonomousProvinceList}
            placeList={this.props.placeList}
            municipalityList={this.props.municipalityList}
            kjsList={this.props.kjsList}
            institutionTypeList={this.props.institutionTypeList}
            findAllPlaceByAutonomousProvince={
              this.props.findAllPlaceByAutonomousProvince
            }
            findAllMunicipalityByPlace={this.props.findAllMunicipalityByPlace}
            findAllKjsByInstitutionType={this.props.findAllKjsByInstitutionType}
            findAllPlaceWithoutAutonomousProvince={
              this.props.findAllPlaceWithoutAutonomousProvince
            }
            clearPlaceList={this.props.clearPlaceList}
            clearMunicipalityList={this.props.clearMunicipalityList}
            clearKjsList={this.props.clearKjsList}
            findAllPlace={this.props.findAllPlace}
            findAllKjs={this.props.findAllKjs}
            findAllKjsFilterPageable={this.props.findAllKjsFilterPageable}
          />
        )}
        <NotificationContainer />
      </Fragment>
    );
  }
}

export default withTranslations(UserTable, 'UserTable');
